/** Created by azhou on 2019/2/18.*/
<template>
    <div class="d-center-start">
      <span :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
      <div class="form-left-text" :style="{width:width+'px'}">{{leftText}}</div>
      <span class="text-dls" :class="[leftText ? '':'text-white']">：</span>
    </div>
</template>

<script>
import { line } from 'echarts/lib/theme/dark';


  export default {
    name: 'LeftText',
    props: {
      leftText: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false
      },
      width: {
        type: Number,
        default:100
      }
    }
  }
</script>

<style lang="scss" scoped>
.form-left-text{
  line-height: 7px;
}
</style>
